const JpGraphSkeleton = () => (
  <div class="loading-skeleton placeholder-glow">
    <div class="loading-bar placeholder"></div>
    <div class="loading-bar placeholder"></div>
    <div class="loading-bar placeholder"></div>
  </div>
)

export default JpGraphSkeleton
